import { Component } from '@angular/core';
import { ProjectElement } from '../../../resources/element/project-element.interface';
import { ElementService } from '../../../resources/element/element.service';
import { RouterService } from '../../../utilities/router/router.service';
import { ElementSidebarService } from '../../../resources/element/element-sidebar/element-sidebar.service';

@Component({
  selector: 'sg2-element-view',
  templateUrl: './element-view.component.html',
  styleUrls: ['./element-view.component.less']
})
export class ElementViewComponent {

  /** Element. */
  public element: ProjectElement;

  constructor(
    public elementSidebarService: ElementSidebarService,
    private elementService: ElementService,
    private routerService: RouterService
  ) {
    const params = this.routerService.getParams();
    this.element = this.elementService.getElementByCode(params.elementCode);
  }
}
